<!--
 * @Description: 描述
 * @Author: D
 * @Date: 2024-03-21 08:14
 * @LastEditTime: 2024-04-19 09:37
 * @LastEditors: D
 * @FilePath: \web\src\components\Home\footer\index.vue
-->
<template>
  <div class="footer">
    <!--页尾 -->
    <div class="contact wrap">
      <div class="contact-auto">
        <el-image class="dimensionalCode">
          <div slot="error" class="image-slot">
            <!-- <i class="el-icon-picture-outline"></i> -->
            <img src="@/assets/img/logo.png" alt="" />
          </div>
        </el-image>
        <ul v-for="item in serviceList" :key="item.id">
          <li class="shengm">{{ item.text }}</li>
          <li
            v-for="item2 in item.optionList"
            :index="item2.id"
            :key="item2.id"
            @click="handleGoDetail(item, item2)"
          >
            {{ item2.text }}
          </li>
        </ul>
        <div>
          <p class="upload-app">下载APP</p>
          <el-image class="dimensionalCode code" :src="appCode">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appCode: "https://car.vip-yych.com/download.png",
      serviceList: [
        {
          id: 1,
          activeId: 4,
          text: "帮助中心",
          optionList: [
            { id: 1, text: "注册协议" },
            { id: 2, text: "拍卖流程图" },
            // { id: 3, text: "参拍流程" },
          ],
        },
        {
          id: 2,
          activeId: 5,
          text: "关于我们",
          optionList: [
            { id: 1, text: "公司简介" },
            { id: 2, text: "资质证明" },
            { id: 3, text: "法律声明" },
            { id: 4, text: "网点信息" },
          ],
        },
      ],
    };
  },
  methods: {
    handleGoDetail(item, item2) {
      console.log(item2, "iem5");
      // this.$store.commit("HANLE_ACTIVE_ID", item.activeId);
      localStorage.setItem("activeId", item.activeId);
      this.$router.push({
        path: item.id == 1 ? "/helpCenter" : "/aboutUs",
        query: {
          activeId: item2.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 260px;
  background-color: #323232;
  margin-top: 20px;

  .contact {
    display: flex;
    justify-content: center;

    .contact-auto {
      width: 700px;
      display: flex;
      justify-content: space-around;
      margin-top: 35px;

      ul {
        .shengm {
          font-size: 22px;
          padding: 0px 0px;
        }

        li {
          color: #999;
          font-size: 14px;
          cursor: pointer;
          margin-bottom: 20px;
        }
      }

      div {
        p {
          font-size: 22px;
          color: #999;
          text-align: left;
        }
      }
    }
  }
}

.upload-app {
  margin-bottom: 10px;
}
.dimensionalCode {
  width: 120px;
  height: 120px;
  line-height: 120px;
  border-radius: 10px;
  text-align: center;

  img {
    width: 100%;
    height: 100%;
  }
}
.code {
  background-color: #eef1f6;
}
</style>